// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';

export interface MergeItemParameters {
  removedItemId: string;
  mergedItemName: string;
  mergedItemSku: string;
  mergedItemBomItemId: string;
}

/**
 * Executes an item merge operation.
 * Merges all data from the removed item into the retained item
 * and permanently deletes the removed item.
 */
export async function mergeItem(
  itemKey: string,
  parameters: MergeItemParameters
): Promise<void> {
  await api.post(`/v1/catalog/item/${itemKey}/merge`, parameters);
}
